// Empty droppable slot in the time grid.
import { useDroppable } from '@dnd-kit/core';
import { Box } from '@mui/material';
import { getOnboardingHighlightSx } from '@/features/onboarding/utils/onboardingHighlightSx';

const TimeSlot = ({ time, date, onboardingHighlight = false }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `${date.toISOString()}|${time}`,
    data: {
      droppable: true,
      date: date,
      time: time,
    },
  });

  return (
    <Box
      className="time-slot"
      data-testid="time-slot"
      sx={{
        height: 'var(--time-slot-height)',
        borderBottom: '1px dotted',
        borderColor: 'grey.200',
        position: 'relative',
        boxSizing: 'border-box',
        flexShrink: 0,
        ...getOnboardingHighlightSx(onboardingHighlight),
        ...(onboardingHighlight ? { outlineOffset: '-2px' } : {}),
      }}
    >
      <Box
        ref={setNodeRef}
        sx={{
          height: '100%',
          width: '100%',
          textIndent: '-9999px',
          overflow: 'hidden',
          boxSizing: 'border-box',
          transition: 'background-color 0.2s ease-in-out',
          bgcolor: isOver ? 'action.hover' : 'transparent',
        }}
      >
        {time}
      </Box>
    </Box>
  );
};

export default TimeSlot;
